'use client';

import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import { useLayoutEffect, useMemo } from 'react';
import { useAdContext } from '@/app_lib/providers/AdProvider';

export const FreeStarScript = () => {
  const { pageAdConfig, arcSpanPageConfig } = useAdContext();
  const arcSpanConfig = useMemo(
    () => ({
      ...pageAdConfig,
      ...arcSpanPageConfig,
    }),
    [pageAdConfig, arcSpanPageConfig],
  );

  // useLayoutEffect runs before paint so ad targeting is set as soon as config is available
  useLayoutEffect(() => {
    for (const [key, value] of Object.entries(arcSpanConfig)) {
      if (value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        FreestarAdSlot.setPageTargeting(key, value);
      }
    }
  }, [arcSpanConfig]);

  return <></>;
};
